const parse = (fmt, value, defaultName, arb) => {
  const pm = fmt.match(/(%[ivsn%]{1}|\s|([^\s]+))/g);

  let r = [];

  for (const m of pm) {
    if (m === '%%') {
      r.push({
        type: 'string',
        value: '%',
      });
    } else if (m === '%i') {
      r.push({
        type: 'icon',
        value: arb ? arb.small_square_ar11_icon_transparent : '',
      });
    } else if (m === '%v') {
      r.push({
        type: 'number',
        value,
      });
    } else if (m === '%s') {
      r.push({
        type: 'string',
        value: arb ? arb.text_display_name_short?.text ?? arb.text_display_name_short : defaultName,
      });
    } else if (m === '%n') {
      r.push({
        type: 'string',
        value: arb ? arb.text_display_name?.text ?? arb.text_display_name : defaultName,
      });
    } else {
      if (m === ' ') {
        r.push({
          type: 'space',
        });
      } else {
        r.push({
          type: 'string',
          value: m + '',
        });
      }
    }
  }

  return r;
};

const prizeCurrencyFormat = (currency, reward_value) => {
  const arb = currency?.art_bundle?.[0];

  const defaultName = arb ? arb.text_display_name?.text ?? arb.text_display_name : currency?.currency_code;

  const defaultFormat = [
    {
      type: 'number',
      value: reward_value,
    },
    {
      type: 'space',
    },
    {
      type: 'string',
      value: defaultName,
    },
  ];

  if (!currency?.format) return defaultFormat;

  if (!arb) return defaultFormat;

  return parse(currency?.format, reward_value, defaultName, arb);
};

export default prizeCurrencyFormat;
